import { observable, action } from 'mobx';
import agent from '../agent';
import commonStore from './commonStore';
import userStore from './userStore';
import imageStore from './imageStore';
import dashboardStore from './dashboardStore';

import React from 'react';
import Images from '../Theme/Images';
import { ReactSVG } from 'react-svg'
import CircularProgress from '@material-ui/core/CircularProgress';

export class TemplateStore {
    @observable inProgress = false;
    @observable statusText;
    @observable errors;
    @observable templateList = [];
    @observable uploadIcon = 'close';
    @observable uploadDialog = false;
    @observable files = []
    @observable uploadProgress = false;
    @observable templateName = '';
    @observable currentTemplate = {};
    @observable currentPage = {};
    @observable currentIndex = 0;
    @observable updatedValues = [];
    @observable updateProgress = false;
    @observable outputMapping = [];
    @observable newOutputMapping = [];
    @observable saveSuccess = false;
    @observable exportType = 'XLS';
    @observable templateName = '';
    @observable localId = ''
    @observable currentField = { style: { height: '0px', width: '0px', display: 'none', top: '0px', left: '0px' } };

    constructor() {
        let templateLocal = window.localStorage.getItem('templateLocal');
        if (templateLocal) {
            templateLocal = JSON.parse(templateLocal);
            this.templateName = templateLocal.currentTemplate.templateName
        }
    }

    @action openUploadDialog(value) {
        this.uploadDialog = value;
        this.templateName = '';
    }

    @action resetOutputMappings(arr) {
        this.outputMapping = arr
    }

    @action handleNameChange(value) {
        if (this.uploadIcon == 'close')
            this.templateName = value
    }

    @action setUploadTemplate(files) {
        this.files = this.files.concat(Array.from(files))
        this.files.forEach(function (element) {
            element.uploadIcon = "close";
        });
    }

    @action getTemplateDetails(templateId) {
        this.inProgress = true;
        this.errors = undefined;
        return agent.Template.getTemplateDetails(templateId)
            .then(action((response) => {
                if (response.statusCode == '200') {
                    this.currentTemplate = response.data;
                    this.templateName = this.currentTemplate.templateName
                    window.localStorage.setItem('templateLocal', JSON.stringify({
                        currentTemplate: this.currentTemplate
                    }));
                    this.currentPage = this.currentTemplate.pageArray[0];
                    if (this.currentPage.labelData.length) {
                        this.currentIndex = 0;
                        this.resetCurrentField();
                    }
                }

            }))
            .catch(action((err) => {
            }))
            .finally(action(() => { this.inProgress = false; }));
    }

    @action getTemplateList() {
        this.inProgress = true;
        this.errors = undefined;
        return agent.Template.getTemplateList()
            .then(action((response) => {
                if (response.statusCode == "200") {
                    this.templateList = response.data.templateList;
                    dashboardStore.setCountData(response.data.countData)
                }

            }))
            .catch(action((err) => {

            }))
            .finally(action(() => { this.inProgress = false; }));
    }

    @action deleteTemplate(templateId) {
        this.inProgress = true;
        this.errors = undefined;
        let temp = [];
        temp.push(templateId)
        return agent.Template.deleteTemplate(temp)
            .then(action((response) => {
                if (response.statusCode == "200") {
                    commonStore.handleOpenSnackBar(response.message, 'success')
                    this.getTemplateList();
                }
                else {
                    commonStore.handleOpenSnackBar(response.message, 'error')
                }

            }))
            .catch(action((err) => {
                commonStore.handleOpenSnackBar('Failed to delete template!', 'error')
            }))
            .finally(action(() => { this.inProgress = false; }));
    }

    @action removeFile(index) {
        this.files.splice(index, 1);
    }

    @action setExportType(value) {
        this.exportType = value
    }

    @action updateExportType(templateId) {
        this.errors = undefined;
        this.inProgress = true;
        this.saveSuccess = false;
        return agent.Template.updateExportType(templateId, this.exportType)
            .then(action((response) => {
                if (response.statusCode == '200') {
                    this.saveSuccess = true;
                    commonStore.handleOpenSnackBar(response.message, 'success');
                }
                else {
                    commonStore.handleOpenSnackBar(response.message, 'error');
                }

            }))
            .catch(action((err) => {
                this.uploadIcon = 'error'
                commonStore.handleOpenSnackBar('Unable to save export type', "error")
            }))
            .finally(action(() => { this.inProgress = false; }));
    }

    @action uploadTemplate() {
        this.errors = undefined;
        this.uploadIcon = 'progress'
        return agent.Template.uploadTemplate(this.files[0], this.templateName)
            .then(action((response) => {
                if (response.statusCode == '200') {
                    this.uploadIcon = 'right'
                    this.getTemplateList()
                }
                else
                    this.uploadIcon = 'error'
            }))
            .catch(action((err) => {
                this.uploadIcon = 'error'
                commonStore.handleOpenSnackBar('Failed to upload template', "error")
            }))
            .finally(action(() => { this.inProgress = false; }));
    }

    @action cancelUpload() {
        this.files = [];
        this.uploadIcon = 'close';
        this.openUploadDialog(false);
        this.templateName = ''
    }


    //Start
    @action setCurrentPage(currentPage, pageNo) {
        this.currentPage = currentPage;
        this.resetCurrentField()
    }

    @action resetCurrentField() {
        this.currentField = { style: { height: '0px', width: '0px', display: 'none', top: '0px', left: '0px' } };
        imageStore.eraseDrawPoint();
    }

    @action updateLabel(value, index, labelId, type) {
        this.currentPage.labelData[index][type] = value;
        let temp = {};
        temp.labelId = labelId;
        temp.labelValue = value;
        let currentIndex = this.updatedValues.findIndex(x => x.labelId == labelId)
        if (currentIndex !== -1)
            this.updatedValues[currentIndex].labelValue = value
        else
            this.updatedValues.push(temp);
    }

    @action saveOutputMapping(templateId) {
        this.inProgress = true;
        this.saveSuccess = false;
        this.outputMapping.forEach(function (v) { delete v.id });
        this.outputMapping.forEach(function (v) { delete v.outputMappingPosition });
        return agent.Template.saveOutputMapping(templateId, this.outputMapping)
            .then(action((response) => {
                if (response.statusCode == "200") {
                    userStore.setLocalTemplate()
                    commonStore.handleOpenSnackBar("Mapping saved successfully.", "success")
                    this.saveSuccess = true
                }
                else
                    commonStore.handleOpenSnackBar(response.message, "error")
                this.outputMapping = this.outputMapping.map((obj, index) => ({ ...obj, id: index }))

            }))
            .catch(action((err) => {
                //this.errors = err.response && err.response.body && err.response.body.errors;
            }))
            .finally(action(() => {
                this.inProgress = false;
            }))
    }

    @action setCurrentField(item, index) {

        this.currentField = item;
        this.currentField.style = { height: '0px', width: '0px' };
        this.currentIndex = index;
    }

    @action updateMappingValue(index, value) {
        this.outputMapping[index].editedLabel = value
    }

    @action selectAllMappings(value) {
        this.outputMapping.forEach((el) => { el.isOutputMappingRequired = value })
    }

    @action updateRequiredMappings(index, value) {
        this.outputMapping[index].isOutputMappingRequired = value
    }

    @action setupUpdatePayload(finalSubmit) {
        let payload = {};
        for (let i = 0; i < this.currentPage.labelData.length; i++) {
            for (let j = 0; j < this.updatedValues.length; j++) {
                if (this.currentPage.labelData[i]._id == this.updatedValues[j].labelId) {
                    this.currentPage.labelData[i].updateProgress = true
                    this.currentPage.labelData[i].progressIcon = <CircularProgress size={30} thickness={5} />
                }
            }
        }
        payload.labelArray = this.updatedValues;
        payload.templateId = this.currentTemplate._id;
        payload.finalFlag = finalSubmit;
        payload.pageId = this.currentPage._id;
        return payload;
    }

    @action updateTemplate(finalSubmit, next) {
        let currentIndex = this.currentTemplate.pageArray.findIndex(x => x._id == this.currentPage._id)
        this.statusText = '';
        this.errors = undefined;
        if (this.updatedValues.length == 0) {
            if (!finalSubmit && !next)
                return;
        }
        //let payload = this.setupUpdatePayload(finalSubmit);
        if (next) {
            if (currentIndex > -1)
                this.setCurrentPage(this.currentTemplate.pageArray[currentIndex + 1], currentIndex + 1)
        }
        /*return agent.Template.updateTemplate(payload)
            .then(action((response) => {
                this.updateProgress = false;
                if (response.statusCode == "200") {
                    if (finalSubmit)
                        this.currentTemplate.pageArray[currentIndex].reviewed = true
                    for (let i = 0; i < this.currentTemplate.pageArray[currentIndex].labelData.length; i++) {
                        for (let j = 0; j < this.updatedValues.length; j++) {
                            if (this.currentTemplate.pageArray[currentIndex].labelData[i]._id == this.updatedValues[j].labelId) {
                                this.currentTemplate.pageArray[currentIndex].labelData[i].progressIcon = <ReactSVG src={Images['fieldRight']} />
                                setTimeout(() => { this.setProgressIcon(i) }, 3000)
                            }
                        }
                    }
                    this.updatedValues = []
                }
                if (finalSubmit)
                    commonStore.handleOpenSnackBar("Document updated successfully!")

            }))
            .catch(action((err) => {
                this.errors = err.response && err.response.body && err.response.body.errors;
            }))
            .finally(action(() => {
                //this.inProgress = false;
            }))*/
    }

    @action updateForm() {
        let payload = this.setupUpdatePayload(false);
        let currentIndex = this.currentTemplate.pageArray.findIndex(x => x._id == this.currentPage._id)
        return agent.Template.updateTemplate(payload)
            .then(action((response) => {
                this.updateProgress = false;
                if (response.statusCode == "200") {
                    for (let i = 0; i < this.currentTemplate.pageArray[currentIndex].labelData.length; i++) {
                        for (let j = 0; j < this.updatedValues.length; j++) {
                            if (this.currentTemplate.pageArray[currentIndex].labelData[i]._id == this.updatedValues[j].fieldId) {
                                this.currentTemplate.pageArray[currentIndex].labelData[i].progressIcon = <ReactSVG src={Images['fieldRight']} />
                                setTimeout(() => { this.setProgressIcon(i) }, 3000)
                            }
                        }
                    }
                    this.updatedValues = []
                }

            }))
            .catch(action((err) => {
                this.errors = err.response && err.response.body && err.response.body.errors;
            }))
            .finally(action(() => {
                //this.inProgress = false;
            }))
    }



    @action getOutputMapping(id) {
        this.inProgress = true;
        return agent.Template.getOutputMapping(id)
            .then(action((response) => {
                if (response.statusCode == "200") {
                    this.templateName = response.data.templateName;
                    this.outputMapping = response.data.outputMapping;
                    this.localId = response.data.localTemplateId
                }
                this.outputMapping = this.outputMapping.map((obj, index) => ({ ...obj, id: index }))
                this.outputMapping.forEach((el) => { if (!el.editedLabel.length) el.editedLabel = el.aiLabel; })
            }))
            .catch(action((err) => {
                this.errors = err.response && err.response.body && err.response.body.errors;
            }))
            .finally(action(() => {
                this.inProgress = false;
            }))
    }


    @action moveTopPosition(top) {
        this.currentField.style.top = parseInt(this.currentTopValue) + parseInt(top) + 'px';
    }
    @action setCurrentTopValue() {
        this.currentTopValue = this.currentField.style.top
    }

    @action setFieldMeasure(h, w, display) {
        this.currentField.style = { height: h, width: w, display: display }
    }

    @action setPosition(top, left) {
        this.currentField.style.top = top;
        this.currentField.style.left = left;
    }

    @action setProgressIcon(index) {
        this.currentPage.labelData[index].progressIcon = <ReactSVG src="" />
    }



}


export default new TemplateStore();
